import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { useCheckInContext } from 'mod/checkIn/useCheckInContext';
import { ResultPopup } from '@pro/420CheckIn/ResultPopup';

export const ShareResult: FC = () => {
    const { shareResultVisible, cancelShareResult, data } = useCheckInContext();
    const { t } = useTrans();

    const { shareBoom } = data;

    return (
        <ResultPopup
            open={shareResultVisible}
            onCancel={cancelShareResult}
        >
            <div className={'g-points'}>{shareBoom.points}</div>
            <div className={'g-line-1'}>
                {t('web_checkin_modal_share_suc_tip', {
                    prev: shareBoom.checkInPoints,
                    next: shareBoom.boomPoints
                })}
            </div>
        </ResultPopup>
    )
};
